import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  tabWrapper: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));
